import Synchro98 from '@/generated/classes/Synchro98';

export interface ResynchAuditRow {
  codeCheque: string;
  codeContrat: number;
  matricule: number;
  contratToSynchronize: boolean;
  paieToSynchronize: boolean;
  paieToCart: boolean;
  paieStatut: number;
  salarieToSynchronize: boolean;
}

export interface ResynchAudit {
  isCompliant: boolean;
  salariesImported: number;
  contratsPaiesImported: number;
  documentsImported: number;
  logoImported: boolean;
  contratsToSynchronize: number;
  paiesToSynchronize: number;
  paiesFinalized: number;
  paiesToCart: number;
  salariesToSynchronize: number;
  documentsToRetrieve: number;
  documentsToDelete: number;
  rows: ResynchAuditRow[];
}

export default class Synchro98Extend extends Synchro98 {
  public resynchAudit: ResynchAudit;

  constructor() {
    super();
    this.resynchAudit = {
      isCompliant: false,
      salariesImported: 0,
      contratsPaiesImported: 0,
      documentsImported: 0,
      logoImported: false,
      contratsToSynchronize: 0,
      paiesToSynchronize: 0,
      paiesFinalized: 0,
      paiesToCart: 0,
      salariesToSynchronize: 0,
      documentsToRetrieve: 0,
      documentsToDelete: 0,
      rows: [],
    };
  }
}
